import { useMemo } from "react";
import { useGetUsersQuery } from "shared/api";
import { adaptUsersToOptions } from "shared/adapters";

export const useUsersOptions = () => {
  const { data: usersResponse, isLoading: isLoadingUsers } = useGetUsersQuery({
    limit: 1000,
    ordering: "first_name",
  });

  const usersOptions = useMemo(
    () => adaptUsersToOptions(usersResponse?.results || []),
    [usersResponse]
  );

  return { usersOptions, isLoadingUsers };
};
